<template>
  <div>
    <section class="w-screen h-auto text-center bg-b2c-grey-300 font-sans-serif"
             aria-label="footer">
      <section class="flex flex-row justify-center pr-20 text-b2c-grey-100" :class="containerClass">
        <section class="flex flex-col justify-center py-6 px-10" :aria-label="$t('footer.logos')">
          <white-salvi-logo class="pt-2 py-6" />
          <white-lyon-logo />
        </section>
        <section class="flex flex-col justify-between" :class="isGermany ? '' : 'w-full'">
          <section class="flex flex-row w-full text-left" :class="isGermany ? 'pb-10' : 'pb-16 justify-between'">
            <nav class="flex flex-col w-full justify-start pt-10">
              <router-link class="p-1" :class="fontHairline()"
                            :to="{ name: 'TermsAndConditions' }">
                {{ $t("footer.terms") }}
              </router-link>
              <router-link class="p-1" :class="fontHairline()"
                            :to="{ name: 'ShippingAndPayments' }">
                {{ $t("footer.shipping") }}
              </router-link>
              <router-link class="p-1" :class="fontHairline()"
                            :to="{ name: 'ReturnAndRefund' }">
                {{ $t("product.returns") }}
              </router-link>
              <router-link class="p-1" :class="fontHairline()"
                            :to="{ name: 'Imprint' }">
                {{ $t("footer.imprint") }}
              </router-link>
            </nav>
            <nav class="flex flex-col w-full justify-start pt-10 h-32" :class="isGermany ? 'pl-20' : ''">
              <router-link class="p-1" :class="fontHairline()" :to="{ name: 'About' }">{{ $t("footer.about")
                }}
              </router-link>
              <a :href="shop.website" class="p-1" :class="fontHairline()">
                {{ $t("footer.shop") }}
              </a>
              <router-link to="/contact" class="pt-1 pl-1" :class="fontHairline()">
                {{ $t("footer.contact") }}
              </router-link>
              <section class="flex ml-1 mt-2 justify-start" :aria-label="$t('footer.socialLogos')" v-if="isGermany">
                <a aria-label="Facebook" class="" :href="shop.facebook">
                  <facebook-logo />
                </a>
              </section>
            </nav>
            <section class="flex ml-1 mt-2 justify-center items-center pt-10" :aria-label="$t('footer.socialLogos')" v-if="!isGermany">
                <a aria-label="Facebook" class="" :href="shop.facebook">
                  <facebook-logo class="w-10" />
                </a>
              </section>
            <section class="text-left w-full" :aria-label="$t('footer.newsletterTitle')" v-if="isGermany">
              <newsletter />
            </section>
          </section>
          <section class="flex flex-row text-sm w-full justify-between border-t">
            <div class="flex flex-col text-left justify-between pt-3 pb-5 font-serif">
              <p class="uppercase">{{ $t("footer.customer-service") }}</p>
              <div class="flex flex-col lg:flex-row items-center justify-between">
                <a class="hover:text-b2c-grey-150 pr-8" :href="'mailto:'+shop.email">{{ shop.email }}</a>
                <span v-if="shop.phone"> {{ shop.phone }} </span>
              </div>
            </div>
            <div class="flex flex-col pl-4" :class="isGermany ? '' : 'w-6/10'">
              <div class="flex flex-row text-left pt-3">
                <lock-icon></lock-icon>
                <p class="text-sm pl-2 font-serif uppercase">{{ $t("product.payment") }}</p>
              </div>
              <div class="flex justify-start items-center pr-1 pb-1"
                        :aria-label="$t('footer.paymentLogos')">
                <paypal-logo aria-label="Paypal Logo" v-if="paymentIsAvailable('paypal')" />
                <mastercard-logo aria-label="Mastercard Logo" v-if="paymentIsAvailable('stripe')" />
                <amex-logo class="pr-2" aria-label="American Express Logo" v-if="paymentIsAvailable('stripe')" />
                <visa-logo class="pr-1" aria-label="Visa Logo" v-if="paymentIsAvailable('stripe')" />
                <img src="/sepa.png" alt="Sepa Direct Debit Logo" class="w-12 px-1" v-if="paymentIsAvailable('sepa')">
                <sofort-logo class="pl-1" aria-label="Sofort Banking Logo" v-if="paymentIsAvailable('sofort')" />
              </div>
            </div>
          </section>
        </section>
      </section>
      <div class="h-auto text-xs w-full text-center pl-32 bg-b2c-grey-600 text-b2c-grey-200">
        <div class="flex flex-row items-center">
          <h4 class="text-xs md:px-2">BeToSee is another fine product of <a
            href="https://www.thenonsensefactory.it">The Nonsense Factory</a></h4>
          <h4 class="text-xs md:px-2">Graphic design by <a
          href="https://www.ivanbarra.it/">Ivan Barra</a></h4>
          <h4 class="text-xs pl-2">{{new Date().getFullYear()}} © Salvi Music</h4>
          <div class="flex flex-row justify-between text-xs pb-2 p-2">
            <button class="px-2" @click="openCookiePolicy">{{ $t("footer.cookie") }}</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import WhiteSalviLogo from '@/components/graphics/WhiteSalviLogo.vue';
import WhiteLyonLogo from '@/components/graphics/WhiteLyonLogo.vue';
import FacebookLogo from '@/components/graphics/FacebookLogo.vue';
import PaypalLogo from '@/components/graphics/PaypalLogo.vue';
import MastercardLogo from '@/components/graphics/MastercardLogo.vue';
import VisaLogo from '@/components/graphics/VisaLogo.vue';
import AmexLogo from '@/components/graphics/AmexLogo.vue';
import LockIcon from '@/components/graphics/LockIcon.vue';
import Newsletter from '@/components/graphics/Newsletter.vue';
import axios from 'axios';
import { mapGetters } from 'vuex';
import { getAvailablePayments } from '@/services/CartService';
import SofortLogo from './SofortLogo.vue';

export default {
  components: {
    WhiteSalviLogo,
    WhiteLyonLogo,
    FacebookLogo,
    PaypalLogo,
    MastercardLogo,
    VisaLogo,
    AmexLogo,
    LockIcon,
    Newsletter,
    SofortLogo,
  },

  data() {
    return {
      paymentMethods: [],
    };
  },

  computed: {
    ...mapGetters({
      isGermany: 'isGermany',
      shop: 'shop',
    }),

    containerClass() {
      if (this.isGermany) {
        return '';
      }
      return 'w-8/12 mx-auto';
    },
  },

  created() {
    this.getPaymentMethods();
  },

  methods: {
    openCookiePolicy() {
      axios.get('/api/cookie-policy')
        .then(({ data }) => {
          window.location.href = data.url;
        });
    },

    getPaymentMethods() {
      getAvailablePayments().then(({ data }) => {
        this.paymentMethods = [];
        this.paymentMethods = data;
      });
    },

    paymentIsAvailable(paymentMethod) {
      return this.paymentMethods.find((method) => method.slug === paymentMethod);
    },
  },
};

</script>
